<template>
    <div>
        <section v-if="showModalTransaction">
            <Transactions
                :transactionDocument="transactionDocument"
                @closeModalTransaction="closeModalTransaction"
                @searchTransaction="findTransactions()"
                :typeTransactionDefault="null"
                @saved="findAccount()"
            />
        </section>
        <section v-if="showFormPayment">
            <FormPayment
                :transactionToPay="transactionToPay"
                :showForm="showFormPayment"
                :isMobile="isMobile"
                @closeForm="closePayment"
                @searchTransaction="findTransactions()"
                @saved="ExecutedPayment()"
            />
        </section>
        <section v-if="showFormReceive">
            <FormReceive
                :transactionToReceive="transactionToReceive"
                :showForm="showFormReceive"
                :isMobile="isMobile"
                @closeForm="closeReceive"
                @searchTransaction="findTransactions()"
                @saved="executedReceive()"
            />
        </section>

        <section style="margin: -5px 0 10px 0; border-bottom: solid 1px var(--cal-header-color-hover);">
            <div class="filter-wrap mb-2">
                <div
                    v-if="possuiPermissao('GER_I_AGENDAMENTOS') && showTopMenuAdd"
                    class="filter mr-2 icon-add-transaction add-btn"
                    @click="showTransaction({})"
                    title="Nova transação"
                >
                    <FilePlusIcon/>
                </div>
                <div
                    v-if="possuiPermissao('GER_P_AGENDAMENTOS') && showTopMenuPay"
                    class="filter mr-2 icon-payment"
                    v-bind:class="!selectedItem ? 'filter-disable' : 'btn-pay-add'"
                    @click="showPaymentOrReceive('All')"
                    title="Registrar pagamento dos selecionados"
                >
                    <CreditCardIcon toolTip="Registrar pagamento dos selecionados"/>
                </div>
                <div
                    v-if="possuiPermissao('GER_C_AGENDAMENTOS')  && showTopMenuCancel"
                    class="filter mr-2 icon-cancel"
                    v-bind:class="!selectedItem ? 'filter-disable' : 'btn-pay-cancel'"
                    @click="confirmCancel('All')"
                    title="Cancelar Selecionados"
                >
                    <XCircleIcon/>
                </div>
                <div
                    v-if="showTopMenuFilter"
                    class="filter"
                    v-bind:class="[showFiltersForm ? 'filter-active' : '']"
                    @click="filterDropDownActive"
                    title="Alterar Filtros"
                >
                    <FilterIcon/>
                </div>
            </div>
        </section>
        <section>
            <Filters
                :showFiltersForm="showFiltersForm"
                :showOptionsfilter="[
                    'account',
                    'transaction_type',
                    'category',
                    'initial_date',
                    'end_date',
                    'type_search_date',
                    'status',
                    'reference',
                    'comments',
                    'rapid_filters',
					'customer'
                ]"
                :optionsAccount="optionsAccount"
                :optionsCategory="optionsCategory"
				:optionsCustomer="optionsCustomer"
                @clickSearch="findTransactions"
                @clickClose="closeFilters"
            />
        </section>

		<section>
			<b-modal
				ref="transactionDetails"
				hide-footer
				size="md"
				no-overflow
				hide-no-focus="true"
				title="Detalhes"
			>
				<div>
					<Label class="text-parcela" style="width: 100%; text-align: center;">Detalhes do pagamento</Label>
					<table style="width: 100%;" class="installment-table">
						<thead>
							<tr>
								<th>Carteira</th>
								<th style="width: 6rem;">Data</th>
								<th style="width: 6rem;">Valor</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(detailAccount, index) in transactionDetails" :key="index"
							>
								<td>{{ detailAccount.description }}</td>
								<td>{{ formatterSimple(detailAccount.date) }}</td>
								<td class="pr-1" style="text-align: right;">{{ numberFormatted(detailAccount.amount) }}</td>

							</tr>
						</tbody>
					</table>
				</div>
				<div>
					<Label class="text-parcela mt-4" style="width: 100%; text-align: center;">Transações pagadas</Label>
					<table style="width: 100%;" class="installment-table">
						<thead>
							<tr>
								<th>{{ titleDetails }}</th>
								<th style="width: 6rem;">Data</th>
								<th style="width: 6rem;">Valor</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(detailSchedule, index) in scheduleDetails" :key="index"
							>
								<td>{{ detailSchedule.description }}</td>
								<td>{{ formatterSimple(detailSchedule.date) }}</td>
								<td class="pr-1" style="text-align: right;">{{ numberFormatted(detailSchedule.amount) }}</td>

							</tr>

						</tbody>
					</table>
				</div>
			</b-modal>
		</section>

        <div v-if="linhas.length && showPagination" class="head-row mb-2 width-pagination-items mt-1">
            <div class="text-head-row width-pagination">
                <label class="text-head-row ml-0">
                    Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + linhas.length }} de {{ pagination.count }}
                </label>
                <b-pagination
                    class="mr-0 mb-2 ml-3"
                    id="page"
                    v-model="currentPage"
                    :total-rows="pagination.count"
                    :per-page="pagination.limit.value"
                ></b-pagination>
            </div>
            <b-form
                class="text-head-row width-pagination">
                <label class="text-head-row ml-0 w-60">
                    Itens por página
                </label>
                <b-form-select
                    class="mr-0 mb-2"
                    v-model="pagination.limit.value"
                    name="itens-por-pagina"
                    :options="optionsItensPorPag"
                    @input="changeItensByPage()"
                    :disabled="loading"
                />
            </b-form>
        </div>
		<div v-if="loading || linhas.length" class="table-responsive">
			<DataTable v-if="!isMobile"
				class="data-table"
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:nosearch="true"
				:nofilters="true"
				name="transacoes"
				:hasPagination="true"
				:noedit="true"
				:acoes="true"
				:permissaoPayment="possuiPermissao('GER_P_AGENDAMENTOS')"
				:permissaoCancel="possuiPermissao('GER_C_AGENDAMENTOS')"
				:permissaoRecover="possuiPermissao('GER_C_AGENDAMENTOS')"
				:permissaoEdit="possuiPermissao('GER_U_AGENDAMENTOS')"
				:permissaoDelete="possuiPermissao('GER_D_AGENDAMENTOS')"
				@clickPayment="showPaymentOrReceive"
				@clickRecover="toRecover"
				@clickCancel="confirmCancel"
				@clickDelete="confirmDelete"
				@clickEdit="showTransaction"
				:selectItem="possuiPermissao('GER_M_AGENDAMENTOS')"
				:alignColumns="alignColumnsTable"
				@clickSortTableBy="(v) => sortTableBy(v)"
				:state="{
					sortBy: sortTable.sortBy,
					sortAsc: sortTable.order === 1,
					query: ''
				}"
				:async="true"
				@clickCheck="showButonsTop"
				:details="!noDetails"
				@clickDetails="showDetails"
			/>
			<CardTransaction v-else
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:acoes="true"
				:permissaoPayment="possuiPermissao('GER_P_AGENDAMENTOS')"
				:permissaoCancel="possuiPermissao('GER_C_AGENDAMENTOS')"
				:permissaoRecover="possuiPermissao('GER_C_AGENDAMENTOS')"
				:permissaoEdit="possuiPermissao('GER_U_AGENDAMENTOS')"
				:permissaoDelete="possuiPermissao('GER_D_AGENDAMENTOS')"
				@clickPayment="showPaymentOrReceive"
				@clickRecover="toRecover"
				@clickCancel="confirmCancel"
				@clickDelete="confirmDelete"
				@clickEdit="showTransaction"
				:selectItem="possuiPermissao('GER_M_AGENDAMENTOS')"
				:globalAcoes="false"
				@clickCheck="showButonsTop"
				:colsDataCard="colsDataCard"
				:details="!noDetails"
				@clickDetails="showDetails"
			/>
		</div>
		<div v-else class="alert alert-warning" role="alert">
			{{ errMsg }}
		</div>
		<div v-if="linhas.length && showPaginationFooter" class="text-head-row d-block">
			<section style="display: flex; justify-content: center;">
				<b-pagination
					id="page"
					class="mb-1"
					v-model="currentPage"
					:total-rows="pagination.count"
					:per-page="pagination.limit.value"
				></b-pagination>
			</section>
			<section style="display: flex; justify-content: center;">
				<label class="text-head-row" style="width: auto;">
					Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + linhas.length }} de {{ pagination.count }}
				</label>
			</section>
		</div>
    </div>
</template>

<script>
	import DataTable from "@/components/DataTable";
	import { numberFormatted, formatterSimple, stringToNumber } from "@/helpers/common";
	import { possuiPermissao } from "../../helpers/permissions";
	import CardTransaction from "@/components/CardTransaction.vue";
	import { STATUS_RECEIVE, TRANSACTIONS_TYPE } from "@/helpers/enums";
	import Transactions from "@/components/Transactions/Transactions.vue";
	import { RelationOperationService } from "../../services/relationOperation";
	import FormPayment from "@/components/Transactions/FormPayment.vue";
	import FormReceive from "@/components/Transactions/FormReceive.vue";
	import Filters from "@/components/Transactions/Filters.vue";
	import emitter from "@/eventBus.js";
	import { PaymentScheduleService } from "../../services/paymentSchedule";
	import { ToReceiveService } from "../../services/toReceive";
	import { mapState } from "vuex";

	import "../../views/Transaction/styles.css";

	export default {
		components: {
			DataTable,
			CardTransaction,
			Transactions,
			FormPayment,
			FormReceive,
			Filters
		},

		props: {
			newRecord: {
				type: Boolean,
				default: false,
				required: false
			},
			showPagination: {
				type: Boolean,
				required: false,
				default: false
			},
			paginationFixed: {
				type: Object,
				required: false
			},
			filtersFixed: {
				type: Object,
				require: false
			},
			showTopMenuAdd: {
				type: Boolean,
				require: false,
				default: true
			},
			showTopMenuPay: {
				type: Boolean,
				require: false,
				default: true
			},
			showTopMenuCancel: {
				type: Boolean,
				require: false,
				default: true
			},
			showTopMenuFilter: {
				type: Boolean,
				require: false,
				default: true
			},
			noDetails: {
				type: Boolean,
				require: false,
				default: false
			},
			showPaginationFooter: {
				type: Boolean,
				required: false,
				default: false
			}
		},

		inject: ["parentValidator"],

		data () {
			return {
				STATUS_RECEIVE,
				TRANSACTIONS_TYPE,
				transactionDocument: {},
				showModalTransaction: false,
				showFormPayment: false,
				showFormReceive: false,
				loading: false,
				filtersSelected: {},
				optionsAccount: [],
				transactions: [],
				showFiltersForm: false,
				optionsCategory: [],
				optionsCustomer: [],
				errMsg: "Nenhum resultado encontrado. Verifique os filtros e tente novamente.",
				colunas: [
					"Descrição",
					"Categoria",
					"Data",
					"Vence",
					"Valor",
					"Tipo",
					"Estado",
					"Referência",
					"Observações"
				],
				alignColumnsTable: [
					"left",
					"left",
					"left",
					"left",
					"right",
					"left",
					"left",
					"left",
					"left"
				],
				colsDataCard: {
					0: {
						idx: 0,
						label: "Descrição",
						textAlign: "left",
						cols: 6,
						visible: true
					},
					1: {
						idx: 1,
						label: "Categoria",
						textAlign: "left",
						cols: 6,
						visible: true
					},
					2: {
						idx: 2,
						label: "Data",
						textAlign: "center",
						cols: 3,
						visible: true
					},
					3: {
						idx: 3,
						label: "Vence",
						textAlign: "center",
						cols: 3,
						visible: true
					},
					4: {
						idx: 4,
						label: "Valor",
						textAlign: "right",
						cols: 3,
						visible: true
					},
					5: {
						idx: 5,
						label: "Tipo",
						textAlign: "left",
						cols: 3,
						visible: true
					},
					6: {
						idx: 6,
						label: "Estado",
						textAlign: "left",
						cols: 4,
						visible: true
					},
					7: {
						idx: 8,
						label: "Obsercações",
						textAlign: "left",
						cols: 8,
						visible: true
					}

				},
				linhas: [],
				currentPage: 1,
				optionsItensPorPag: [
					{
						value: 5,
						text: "5 Items"
					},
					{
						value: 25,
						text: "25 Items"
					},
					{
						value: 50,
						text: "50 Items"
					},
					{
						value: 75,
						text: "75 Items"
					},
					{
						value: 100,
						text: "100 Items"
					}
				],
				selectItem: false,
				relationOperationService: new RelationOperationService(),
				paymentScheduleService: new PaymentScheduleService(),
				toReceiveService: new ToReceiveService(),

				possuiPermissao,
				sortTable: {
					sortBy: 2,
					order: -1
				},
				selectedItem: false,
				isMobile: false,
				accountBalance: "0,00",
				saving: false,
				transactionToPay: [],
				pagination: {
					count: 0,
					page: 1,
					offset: 0,
					limit: {
						value: 25
					},
					pages: 1
				},
				config: {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				},
				transactionDetails: [],
				scheduleDetails: [],
				formatterSimple,
				numberFormatted,
				titleDetails: ""
			};
		},

		computed: {
			...mapState(["account", "category", "customer"])
		},

		watch: {
			currentPage () {
				this.changePage();
			},

			filters () {
				this.linhas = [];
			},
			account () {
				this.optionsAccount = this.account;
			}
		},

		async mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);

			this.optionsAccount = this.account;
			this.optionsCategory = this.category;
			this.optionsCustomer = this.customer;

			emitter.on("reloadListTransaction", (reload) => {
				if (reload) {
					this.optionsAccount = this.account;
					this.findTransactions();
				}
			});
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
			emitter.off("reloadListTransaction");
		},

		methods: {
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			closeFilters () {
				this.showFiltersForm = false;
			},

			closeModalTransaction () {
				this.showModalTransaction = false;
			},

			closePayment () {
				this.showFormPayment = false;
			},

			closeReceive () {
				this.showFormReceive = false;
			},

			async findAccount () {

			},

			async findTransactions (filtersSelected) {
				if (filtersSelected) {
					this.pagination.page = 1;
				}

				if (this.paginationFixed) {
					this.pagination = this.paginationFixed;
				}
				if (this.filtersFixed) {
					filtersSelected = this.filtersFixed;
				}

				this.showFiltersForm = false;
				const limit = this.pagination.limit.value;
				this.pagination.offset = (this.pagination.page - 1) * limit;
				const offset = this.pagination.offset;
				const sortTable = this.sortTable;

				if (filtersSelected) {
					this.filtersSelected = filtersSelected;
				}

				this.filtersSelected.limit = limit || null;
				this.filtersSelected.offset = offset;
				this.filtersSelected.sortTable = sortTable;

				this.loading = true;
				const result = await this.relationOperationService.getTransactionsFromAllSources(this.filtersSelected) || {};
				this.transactions = result.rows;
				this.linhas = result.rows.reduce((acc, c) => [
					...acc,
					{
						idOperation: c.idOperation,
						idPaymentSchedule: c.idPaymentSchedule,
						idToReceive: c.idToReceive,
						idTransaction: c.idTransaction,
						selected: false,
						notItemActions: false,
						hidePayment: Boolean(c.status !== "ACTIVE"),
						hideCancel: Boolean(c.status !== "ACTIVE"),
						hideEdit: Boolean(c.status !== "ACTIVE"),
						hideDelete: Boolean(c.status === "ACTIVE"),
						notItemSelect: Boolean(c.status !== "ACTIVE"),
						isCanceled: Boolean(c.status === "CANCELED"),
						UUID: c.UUID,
						installments: c.installments,
						type: c.transactionType,
						details: c.details || null,
						noDetails: Boolean(!c.details),
						scheduleDetails: c.scheduleDetails,
						cols: [
							c.accountName ? c.accountName : "",
							c.categoryName ? c.categoryName : "",
							formatterSimple(c.transactionDate),
							c.scheduleDate ? formatterSimple(c.scheduleDate) : "-",
							numberFormatted(c.transactionAmount),
							TRANSACTIONS_TYPE[c.transactionType] || "",
							STATUS_RECEIVE[c.status],
							c.reference,
							c.comments
						]
					}
				], []);

				this.pagination.count = result.count || 0;
				this.pagination.pages = this.pagination.count > limit ? Math.ceil(this.pagination.count / limit) : 1;
				this.loading = false;
				if (this.showFiltersForm)
					this.showFiltersForm = false;

				this.$emit("rowsRequest", this.linhas.length);

			},

			sortTableBy (v) {
				this.sortTable = v;
				this.findTransactions();
			},

			changePage () {
				this.pagination.page = this.currentPage;
				this.findTransactions();
			},

			changeItensByPage () {
				this.pagination.page = 1;
				this.findTransactions();
			},

			async showTransaction (item_) {

				let item = {};
				if (item_.idOperation) {
					[ item ] = this.transactions.filter(c => c.idOperation === item_.idOperation);
				}

				this.showModalTransaction = true;
				this.transactionDocument = item;
			},

			async confirmDelete (item_, notDeleteRecord) {
				const deleteRecord = !notDeleteRecord;

				if (typeof (item_) === "string") {
					this.deleteMulti();
					return;
				}

				const [ item ] = this.transactions.filter((gu) => gu.idOperation === item_.idOperation);

				let text = "Tem certeza que deseja cancelar a transação?";
				if (deleteRecord) {
					text = text.concat(" O cancelamento desta operação implicará na reversão de todas as transações executadas em conjunto.");
				}

				const deleteConfirmation = (await this.$swal({
					title: "Cancelar",
					text,
					type: "error",
					showCancelButton: true,
					cancelButtonColor: "#A6A8AB",
					confirmButtonColor: "#DD6B55",
					imageWidth: 50,
					imageHeight: 50,
					cancelButtonText: "Não",
					confirmButtonText: "Sim",
					reverseButtons: true
				})).value;

				if (deleteConfirmation)
					this.delete(item, deleteRecord);
			},

			async delete (item, deleteRecord) {
				const operations = {
					transactions: { idsTransaction: [], idsOperation: [] },
					paymentSchedule: { idsPaymentSchedule: [], idsOperation: [] },
					toReceive: { idsToReceive: [], idsOperation: [] }
				};

				if (item.idTransaction) {
					operations.transactions.idsOperation.push(item.idOperation);
					operations.transactions.idsTransaction.push(item.idTransaction);

				} else if (item.idPaymentSchedule) {
					operations.paymentSchedule.idsOperation.push(item.idOperation);
					operations.paymentSchedule.idsPaymentSchedule.push(item.idPaymentSchedule);

				} else {
					operations.toReceive.idsOperation.push(item.idOperation);
					operations.toReceive.idsToReceive.push(item.idToReceive);
				}

				if (!operations.transactions.idsTransaction.length && !operations.paymentSchedule.idsPaymentSchedule.length && !operations.toReceive.idsToReceive.length) return;
				this.$snotify.async("Aguarde...", "Cancelando", async () => {
					try {
						const payload = { operations, deleteRecord };
						await this.relationOperationService.deleteOperation({payload});

						if ( this.$route.path === "/")
							emitter.emit("reloadTransactions", { reload: true });

						this.findTransactions();
						emitter.emit("reloadAccount", { reload: true });

						return {
							title: "Sucesso!",
							body: "Transação cancelada com sucesso.",
							config: this.config
						};
					} catch (error) {
						const msgError = error.response.data.message || "Erro ao tentar cancelar a Transação!";
						throw {
							title: "Falha!",
							body: msgError,
							config: this.config
						};
					}
				});
			},

			filterDropDownActive () {
				this.showFiltersForm = !this.showFiltersForm;
			},

			async deleteMulti () {
				const operations = {
					transactions: { idsTransaction: [], idsOperation: [] },
					paymentSchedule: { idsPaymentSchedule: [], idsOperation: [] },
					toReceive: { idsToReceive: [], idsOperation: [] }
				};

				this.linhas.forEach((item) => {
					if (item.selected) {
						if (item.idTransaction) {
							operations.transactions.idsOperation.push(item.idOperation);
							operations.transactions.idsTransaction.push(item.idTransaction);

						} else if (item.idPaymentSchedule) {
							operations.paymentSchedule.idsOperation.push(item.idOperation);
							operations.paymentSchedule.idsPaymentSchedule.push(item.idPaymentSchedule);

						} else {
							operations.toReceive.idsOperation.push(item.idOperation);
							operations.toReceive.idsToReceive.push(item.idToReceive);
						}
					}
				});

				if (!operations.transactions.idsTransaction.length && !operations.paymentSchedule.idsPaymentSchedule.length && !operations.toReceive.idsToReceive.length) return;

				const deleteConfirmation = (await this.$swal({
					title: "Cancelar",
					text: "Tem certeza que deseja cancelar as transações selecionadas?",
					type: "error",
					showCancelButton: true,
					cancelButtonColor: "#A6A8AB",
					confirmButtonColor: "#DD6B55",
					imageWidth: 50,
					imageHeight: 50,
					cancelButtonText: "Não",
					confirmButtonText: "Sim",
					reverseButtons: true
				})).value;

				if (!deleteConfirmation)
					return;

				this.$snotify.async("Aguarde...", "Cancelando", async () => {
					try {
						const payload = { operations };
						await this.relationOperationService.deleteOperation({payload});

						if ( this.$route.path === "/")
							emitter.emit("reloadTransactions", { reload: true });

						this.findTransactions();
						emitter.emit("reloadAccount", { reload: true });

						return {
							title: "Sucesso!",
							body: "transações canceladas com sucesso.",
							config: this.config
						};
					} catch (error) {
						const msgError = error.response.data.message || "Erro ao tentar cancelar as Transações!";
						throw {
							title: "Falha!",
							body: msgError,
							config: this.config
						};
					}
				});
			},

			showButonsTop () {
				this.selectedItem = this.linhas.some(linha => linha.selected);
			},

			async confirmCancel (item) {
				this.confirmDelete(item, true);
			},

			showPaymentOrReceive (item_) {
				this.transactionToPay = [];
				this.transactionToReceive = [];

				if (typeof item_ === "string") {
					this.linhas.forEach(item => {
						if (item.selected && !item.idTransaction) {
							if (item.type === "TOPAY") {
								this.transactionToPay.push({ idOperation: item.idOperation, idPaymentSchedule: item.idPaymentSchedule, valor: stringToNumber(item.cols[4]) });
							} else if (item.type === "TORECEIVE") {
								this.transactionToReceive.push({ idOperation: item.idOperation, idToReceive: item.idToReceive, valor: stringToNumber(item.cols[4]) });
							}
						}
					});
					if (this.transactionToReceive.length) {
						this.showFormReceive = true;
					}
					if (this.transactionToPay.length) {
						this.showFormPayment = true;
					}

				} else {
					if (item_.idToReceive) {
						this.transactionToReceive = [{ idOperation: item_.idOperation, idToReceive: item_.idToReceive, valor: stringToNumber(item_.cols[4]) }];
						this.showFormReceive = true;

					} else if (item_.idPaymentSchedule) {
						this.transactionToPay = [{ idOperation: item_.idOperation, idPaymentSchedule: item_.idPaymentSchedule, valor: stringToNumber(item_.cols[4]) }];
						this.showFormPayment = true;

					}
				}
			},

			async toRecover (item_) {
				const [ item ] = this.transactions.filter((gu) => gu.idOperation === item_.idOperation);
				if (item.isCanceled) return;

				if (item.paymentedDate) {
					await this.$swal({
						title: "Recuperar",
						text: "Agendamento já pago, não pôde ser recuperado!",
						type: "error",
						showCancelButton: false,
						imageWidth: 50,
						imageHeight: 50,
						confirmButtonColor: "rgb(132, 170, 194)",
						confirmButtonText: "Ok"
					});
					return;
				}

				const recoverConfirmation = (await this.$swal({
					title: "Recuperar",
					text: "Tem certeza que deseja recuperar o agendamento?",
					type: "error",
					showCancelButton: true,
					cancelButtonColor: "#A6A8AB",
					confirmButtonColor: "#DD6B55",
					imageWidth: 50,
					imageHeight: 50,
					cancelButtonText: "Não",
					confirmButtonText: "Sim",
					reverseButtons: true
				})).value;

				if (recoverConfirmation)
					this.recover(item);

			},

			async recover (item) {
				const payload = {};
				if (item.idPaymentSchedule) {
					payload.idsPaymentSchedule = [item.idPaymentSchedule];
				} else if (item.idToReceive) {
					payload.idsToReceive = [item.idToReceive];
				} else {
					return;
				}

				this.$snotify.async("Aguarde...", "Recuperando", async () => {
					try {
						if (payload.idsPaymentSchedule) {
							await this.paymentScheduleService.recoverPaymentSchedule({payload});
						} else {
							await this.toReceiveService.recoverToReceive({payload});
						}
						this.findTransactions();
						if ( this.$route.path === "/")
							emitter.emit("reloadTransactions", { reload: true });

						return {
							title: "Sucesso!",
							body: "Agendamento recuperado com sucesso.",
							config: this.config
						};
					} catch (error) {
						const msgError = error.response.data.message || "Erro ao tentar recuperar o agendamento!";
						throw {
							title: "Falha!",
							body: msgError,
							config: this.config
						};
					}
				});
			},

			executedReceive () {
				this.findTransactions();
				this.showFormReceive = false;
			},

			ExecutedPayment () {
				this.findTransactions();
				this.showFormPayment = false;
			},

			showDetails (item) {
				this.titleDetails = item.idToReceive ? "Cliente" : "Beneficiario/Credor";
				this.transactionDetails = item.details || [];
				this.scheduleDetails = item.scheduleDetails || [];
				if (this.transactionDetails.length)
					this.$refs.transactionDetails.show();

			}
		}
	};
</script>
